import I18n from 'i18n'
import { ReactDatePickerProps } from 'react-datepicker'
import { localeDefinition } from './Locales'

export const getDatePickerLocale = (): Partial<ReactDatePickerProps> => {
  return {
    locale: localeDefinition().dateFns,
    timeCaption: I18n.t('time.time')
  }
}
